angular.module('satv.track')

    .factory('TrackNote', ['config', '$resource', function (config, $resource) {
        return $resource((config.userAPI || config.apiUri) + '/track/notes/:id', {
            id: '@id'
        }, {
            save: {
                method: 'POST'
            }
        });
    }])

    .factory('TrackNoteLoader', ['TrackNote', '$q', function (TrackNote, $q) {
        return function (params) {
            var delay = $q.defer();

            TrackNote.query(params, function (notes) {
                delay.resolve(notes);
            }, function () {
                delay.reject('Unable to fetch TrackNotes');
            });

            return delay.promise;
        };
    }])

    .factory('TrackNotesLoader', ['TrackNote', 'LoaderFactory', function (TrackNote, LoaderFactory) {
        return function (params) {
            return new LoaderFactory(TrackNote, params);
        };
    }])

;



// WEBPACK FOOTER //
// ./vendor/sonyatv/smfcoreclientbundle/Resources/js/angular/services/TrackNote.js